import { Flex, Text } from "@chakra-ui/react";
import { FC } from "react";
import { TaskElement } from "../../../hooks/api/karl-farm/useAllTasks";
import { Score } from "../../../hooks/api/karl-farm/useScores";
import { ConditionBadge } from "./ConditionBadge";

type ConditionsProps = {
  task: TaskElement;
  score?: Score;
};
export const Conditions: FC<ConditionsProps> = ({ task, score }) => {
  const descriptions = score?.description;

  const conditionsUnavailable =
    descriptions == null ||
    Object.values(descriptions).every((level) => level == null);

  return (
    <>
      {conditionsUnavailable ? (
        <Text>Conditions unavailable.</Text>
      ) : (
        <Flex direction="column" gap="12px">
          {descriptions.precipitation?.description != null && (
            <ConditionBadge
              score={score}
              task={task}
              type={"precipitation"}
              level={descriptions.precipitation.description}
            />
          )}
          {descriptions.temperature?.description != null && (
            <ConditionBadge
              score={score}
              task={task}
              type={"temperature"}
              level={descriptions.temperature.description}
            />
          )}
          {descriptions.soil_temperature?.description != null && (
            <ConditionBadge
              score={score}
              task={task}
              type={"soil_temperature"}
              level={descriptions.soil_temperature.description}
            />
          )}
          {descriptions.soil_moisture?.description != null && (
            <ConditionBadge
              score={score}
              task={task}
              type={"soil_moisture"}
              level={descriptions.soil_moisture.description}
            />
          )}
          {descriptions.clouds?.description != null && (
            <ConditionBadge
              score={score}
              task={task}
              type={"clouds"}
              level={descriptions.clouds.description}
            />
          )}
          {descriptions.wind?.description != null && (
            <ConditionBadge
              score={score}
              task={task}
              type={"wind"}
              level={descriptions.wind.description}
            />
          )}
          {descriptions.gusts?.description != null && (
            <ConditionBadge
              score={score}
              task={task}
              type={"gusts"}
              level={descriptions.gusts.description}
            />
          )}
        </Flex>
      )}
    </>
  );
};
